import React from "react";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { Logo } from "./Logo";

// X (Twitter) — Lucide doesn't ship the new X mark, so use an inline SVG.
const XIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M18.244 2H21l-6.55 7.49L22.5 22H16.5l-4.71-6.18L6.4 22H3.64l7.02-8.03L2 2h6.13l4.26 5.65L18.244 2zm-2.36 18h1.62L7.2 4H5.48L15.884 20z" />
  </svg>
);

export const Footer = () => {
  const quickLinks = [
    { label: "Home", href: "/#home" },
    { label: "Calculator", href: "/#calculator" },
    { label: "Services", href: "/#services" },
    { label: "Contact", href: "mailto:hello@metamonk.co" },
    { label: "Privacy Policy", href: "/privacy" },
  ];

  return (
    <footer
      id="contact"
      style={{ backgroundColor: "#0D1117" }}
      className="py-12 pt-16"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <Logo />
            <p
              className="mt-4"
              style={{ color: "rgba(255,255,255,0.5)", fontSize: 14, lineHeight: 1.6 }}
            >
              Your Financial Growth Partner
            </p>
            <p
              className="mt-2"
              style={{ color: "rgba(255,255,255,0.4)", fontSize: 13 }}
            >
              Chennai, Tamil Nadu, India
            </p>
            <div className="mt-5 flex items-center gap-4">
              <a
                href="https://www.facebook.com/themetamonk"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="transition-colors hover:text-white"
                style={{ color: "rgba(255,255,255,0.4)" }}
                data-testid="footer-social-facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://www.instagram.com/themeta_monk/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="transition-colors hover:text-white"
                style={{ color: "rgba(255,255,255,0.4)" }}
                data-testid="footer-social-instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.youtube.com/@themeta_monk"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="transition-colors hover:text-white"
                style={{ color: "rgba(255,255,255,0.4)" }}
                data-testid="footer-social-youtube"
              >
                <Youtube size={18} />
              </a>
              <a
                href="https://x.com/themeta_monk"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X"
                className="transition-colors hover:text-white"
                style={{ color: "rgba(255,255,255,0.4)" }}
                data-testid="footer-social-x"
              >
                <XIcon size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <div
              className="uppercase font-semibold"
              style={{
                color: "#1D9E75",
                fontSize: 12,
                letterSpacing: "0.12em",
              }}
            >
              Quick Links
            </div>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="transition-colors hover:text-white"
                    style={{ color: "rgba(255,255,255,0.5)", fontSize: 14 }}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Disclaimer */}
          <div>
            <div
              className="uppercase font-semibold"
              style={{
                color: "#1D9E75",
                fontSize: 12,
                letterSpacing: "0.12em",
              }}
            >
              Disclaimer
            </div>
            <p
              className="mt-4"
              style={{
                color: "rgba(255,255,255,0.35)",
                fontSize: 11,
                lineHeight: 1.6,
              }}
            >
              Meta Monk Ventures is a registered proprietorship. Mutual fund
              investments are subject to market risks. Please read all scheme
              related documents carefully. Insurance is the subject matter of
              solicitation. This website is for informational purposes only and
              does not constitute financial advice.
            </p>
          </div>
        </div>

        <div
          className="mt-10 pt-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2"
          style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
        >
          <div style={{ color: "rgba(255,255,255,0.3)", fontSize: 12 }}>
            © {new Date().getFullYear()} Meta Monk Ventures. All rights reserved.
          </div>
          <div style={{ color: "rgba(255,255,255,0.3)", fontSize: 12 }}>
            Built with purpose in Chennai.
          </div>
        </div>
      </div>
    </footer>
  );
};
